import * as React from "react"
import type { ChartDetailEntry } from "./model_detail"
import { BarChart } from "../modelling/controls/barchart"
import { SankeyDetail } from "../modelling/controls/sankey"
import { DatasetSnapshotChart, SpiderSnapshotChart, TableCompareSnapshotChart, TableSnapshotChart } from "../modelling/controls/dataset_chart"

export function ChartDetailBody({
  entry,
  expanded = true,
  contained = false,
}: {
  entry: ChartDetailEntry
  expanded?: boolean
  contained?: boolean
}) {
  if (entry.kind === "bar") {
    return <BarChart variables={entry.variables} title={entry.name} />
  }
  if (entry.kind === "sankey") {
    return <SankeyDetail variables={entry.variables} title={entry.name} />
  }
  if (entry.kind === "table") {
    if (!entry.chart) return null
    return <TableSnapshotChart chart={entry.chart} expanded={expanded} />
  }
  if (entry.kind === "tableCompare") {
    if (!entry.chart) return null
    return <TableCompareSnapshotChart chart={entry.chart} expanded={expanded} />
  }
  if (entry.kind === "spider") {
    if (!entry.chart) return null
    return <SpiderSnapshotChart chart={entry.chart} expanded={expanded} contained={contained} />
  }
  if (!entry.chart) return null
  return <DatasetSnapshotChart chart={entry.chart} kind={entry.kind} expanded={expanded} />
}
